import "./FooterSoMeLink.scss";
import React from "react";
import { LinkProps } from "/Models/Generated/LinkProps";

import { IconProps } from "/Components/Icons/IconProps";
import { ColorTheme } from "/Models/Models/ColorTheme";

export interface Props extends LinkProps {
  icon: React.FC<IconProps>;
}

const FooterSoMeLink = ({ href, target, text, icon }: Props) => {
  const IconComp = icon as React.FC<IconProps>;
  return (
    <div className="footer-some-link-norad">
      {href && (
        <a className="footer-some-link-norad__link" {...{ target, href }}>
          <IconComp size={"32"} thickness={"Reg"} color={ColorTheme.green} />
          <span className="footer-some-link-norad__text">{text}</span>
        </a>
      )}
    </div>
  );
};

export default FooterSoMeLink;
